import {
  DOPPEL_BREACH_RED,
  DOPPEL_GREY_50,
  DOPPEL_GREY_200,
  DOPPEL_GREY_500,
} from '@/utils/style'
import { WarningIcon } from '@chakra-ui/icons'
import { Text, Icon, StackProps, Stack, Button } from '@chakra-ui/react'

type ErrorComponentProps = {
  errorText: string
  message?: string
  stackDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  fontSize?: string
  iconSize?: number
  hideIcon?: boolean
  icon?: React.ElementType
  iconColor?: string
  buttonText?: string
  onButtonClick?: () => void
} & StackProps

/**
 * To be injected in place of an erroring component
 * e.g. lack of necessary data, graphql error, scoped error boundary
 */
const ErrorComponent = ({
  errorText,
  message,
  stackDirection = 'row',
  fontSize,
  iconSize,
  hideIcon = false,
  icon = WarningIcon,
  iconColor = DOPPEL_BREACH_RED,
  buttonText,
  onButtonClick,
  ...props
}: ErrorComponentProps) => {
  return (
    <Stack
      align="center"
      direction={stackDirection}
      justify="center"
      spacing={4}
      {...props}
    >
      {!hideIcon && (
        <Icon as={icon} boxSize={iconSize} color={iconColor} name="error" />
      )}

      <Stack align="center" spacing={2}>
        <Text
          fontSize={fontSize}
          fontWeight="semibold"
          lineHeight={1}
          textColor={DOPPEL_GREY_50}
        >
          {errorText}
        </Text>

        {message && (
          <Text
            fontSize={fontSize ? `calc(${fontSize} * 0.85)` : undefined}
            lineHeight={1.25}
            maxWidth="320px"
            textAlign="center"
            textColor={DOPPEL_GREY_200}
          >
            {message}
          </Text>
        )}

        {buttonText && onButtonClick && (
          <Button
            backgroundColor={DOPPEL_GREY_500}
            borderRadius="100px"
            mt={2}
            onClick={onButtonClick}
            padding="14px"
            size="sm"
            variant="outline"
          >
            {buttonText}
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

export default ErrorComponent
